import { useEffect, useState } from 'react';

export const useInitialInfoDialog = (
  trigger: boolean | undefined,
  isActive: boolean,
  hasContent: boolean,
  onShown?: () => void
): { open: boolean; close: () => void } => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!trigger || !isActive) return;
    if (hasContent) setOpen(true);
    onShown?.();
  }, [trigger, isActive, hasContent]);

  return { open, close: () => setOpen(false) };
};
